import { render, staticRenderFns } from "./addGameList.vue?vue&type=template&id=02a2b78a&"
import script from "./addGameList.vue?vue&type=script&lang=js&"
export * from "./addGameList.vue?vue&type=script&lang=js&"
import style0 from "./addGameList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a2b78a')) {
      api.createRecord('02a2b78a', component.options)
    } else {
      api.reload('02a2b78a', component.options)
    }
    module.hot.accept("./addGameList.vue?vue&type=template&id=02a2b78a&", function () {
      api.rerender('02a2b78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addGameList.vue"
export default component.exports